/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Manage_NoneInputs */

const en_story_manage_none = /** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active stories found.`)
};

const es_story_manage_none = /** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron historias activas.`)
};

const fr_story_manage_none = /** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune story active trouvée.`)
};

const de_story_manage_none = /** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine aktiven Stories gefunden.`)
};

const id_story_manage_none = /** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ditemukan cerita aktif.`)
};

/** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */
const ja_story_manage_none = en_story_manage_none;

/** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */
const zh_story_manage_none = en_story_manage_none;

/** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */
const ar_story_manage_none = en_story_manage_none;

/** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */
const it_story_manage_none = en_story_manage_none;

/** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */
const ru_story_manage_none = en_story_manage_none;

/** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */
const pt_story_manage_none = en_story_manage_none;

/** @type {(inputs: Story_Manage_NoneInputs) => LocalizedString} */
const ko_story_manage_none = en_story_manage_none;

/**
* | output |
* | --- |
* | "No active stories found." |
*
* @param {Story_Manage_NoneInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_manage_none = /** @type {((inputs?: Story_Manage_NoneInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Manage_NoneInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_manage_none(inputs)
	if (locale === "es") return es_story_manage_none(inputs)
	if (locale === "fr") return fr_story_manage_none(inputs)
	if (locale === "de") return de_story_manage_none(inputs)
	if (locale === "ja") return ja_story_manage_none(inputs)
	if (locale === "zh") return zh_story_manage_none(inputs)
	if (locale === "ar") return ar_story_manage_none(inputs)
	if (locale === "id") return id_story_manage_none(inputs)
	if (locale === "it") return it_story_manage_none(inputs)
	if (locale === "ru") return ru_story_manage_none(inputs)
	if (locale === "pt") return pt_story_manage_none(inputs)
	return ko_story_manage_none(inputs)
});